export const penaltiesSplit = (str: string): Array<string> => {
  const splitArray = str.split(/\(/, 2);
  if (typeof splitArray[1] === "string") {
    splitArray[1] = "(" + splitArray[1];
  }
  return splitArray;
};
